import MerchMaker from './MerchMaker'

export default MerchMaker
